import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _aiTheme;
/**
 * TODO AIFOLLOWUP ED-18808, EDITOR-56:
 * This should no longer be needed once token case been finalised + added.
 * Once AI tokens are available, replace usages of `aiThemeColor` with
 * the correct tokens.
 */

import { useThemeObserver } from '@atlaskit/tokens';
export var useAIThemeColor = function useAIThemeColor() {
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode;
  return function (key) {
    return aiTheme[key][colorMode || 'light'];
  };
};
var aiTheme = (_aiTheme = {}, _defineProperty(_aiTheme, 'prism.border.step.1', {
  light: '#0065FF',
  // Blue
  dark: '#0065FF' // Blue
}), _defineProperty(_aiTheme, 'prism.border.step.2', {
  light: '#0469FF',
  // Blue
  dark: '#0469FF' // Blue
}), _defineProperty(_aiTheme, 'prism.border.step.3', {
  light: '#BF63F3',
  // Purple
  dark: '#BF63F3' // Purple
}), _defineProperty(_aiTheme, 'prism.border.step.4', {
  light: '#FFA900',
  // Yellow
  dark: '#FFA900' // Yellow
}), _defineProperty(_aiTheme, 'icon.brand', {
  light: '#44546F',
  dark: '#9FADBC'
}), _defineProperty(_aiTheme, 'telepointer.background.step.1', {
  light: '#F8E6A0',
  dark: '#F5CD47'
}), _defineProperty(_aiTheme, 'telepointer.background.step.2', {
  light: '#8BDBE5',
  dark: '#60C6D2'
}), _defineProperty(_aiTheme, 'telepointer.background.step.3', {
  light: '#0C66E4',
  // Blue700
  dark: '#388BFF' // Blue500
}), _defineProperty(_aiTheme, 'loading.step.1', {
  light: '#0C66E4',
  // Blue700
  dark: '#0C66E4' // Blue700
}), _defineProperty(_aiTheme, 'loading.step.2', {
  light: '#1D7AFC',
  // Blue600
  dark: '#1D7AFC' // Blue600
}), _defineProperty(_aiTheme, 'loading.step.3', {
  light: '#388BFF',
  // Blue500
  dark: '#388BFF' // Blue500
}), _aiTheme);